import { render, staticRenderFns } from "./approvalDetail.vue?vue&type=template&id=68eeeb61&scoped=true&"
import script from "./approvalDetail.vue?vue&type=script&lang=js&"
export * from "./approvalDetail.vue?vue&type=script&lang=js&"
import style0 from "./approvalDetail.vue?vue&type=style&index=0&id=68eeeb61&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eeeb61",
  null
  
)

export default component.exports